var map = {
	"./courses/courses.module": [
		"./src/app/courses/courses.module.ts",
		"courses-courses-module"
	],
	"./editor/editor.module": [
		"./src/app/editor/editor.module.ts",
		"default~editor-editor-module~gallery-gallery-module",
		"editor-editor-module"
	],
	"./gallery/gallery.module": [
		"./src/app/gallery/gallery.module.ts",
		"default~editor-editor-module~gallery-gallery-module",
		"gallery-gallery-module"
	],
	"./intro/intro.module": [
		"./src/app/intro/intro.module.ts",
		"intro-intro-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;